import Vue from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'
import lineClamp from 'vue-line-clamp'
import clipboard from 'v-clipboard'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
Vue.use(VueGtag, {
  config: {id: 'G-BSNCGMV709'}
}, router);
Vue.use(lineClamp, {
  importCss: true
})
Vue.use(clipboard)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
